import { render, staticRenderFns } from "./LastSync.vue?vue&type=template&id=428dfe40&scoped=true"
import script from "./LastSync.vue?vue&type=script&lang=ts"
export * from "./LastSync.vue?vue&type=script&lang=ts"
import style0 from "./LastSync.vue?vue&type=style&index=0&id=428dfe40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428dfe40",
  null
  
)

export default component.exports